import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import "swiper/css/bundle"

// ⚠️ 重要：必須在 App 渲染之前初始化 Firebase App Check
import "./firebase"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
